import { FormattedNumber } from 'react-intl';
import { styled } from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import commonEssence from '@sorare/core/src/assets/rewards/common-essence.webp';
import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const CommonEssenceIcon = styled.img.attrs({ src: commonEssence, alt: '' })`
  height: 1.1em;
`;

export const CommonMarketStatus = () => {
  const { currentUser } = useCurrentUserContext();
  const pointsCount = currentUser?.commonCardPoints || 0;
  const cardsCount = currentUser?.cardCounts?.common || 0;
  if (!currentUser) return null;
  return (
    <Horizontal>
      <CommonEssenceIcon />
      <LabelM as="span" color="var(--c-white)">
        <FormattedNumber value={pointsCount} />
      </LabelM>
      <LabelM as="span" color="var(--c-nd-400)">
        •
      </LabelM>
      <ScarcityIcon rarity={Rarity.common} />
      <LabelM
        as="span"
        color={cardsCount < 9 ? 'var(--c-yellow-400)' : 'var(--c-white)'}
      >
        {cardsCount}
      </LabelM>
    </Horizontal>
  );
};
